import React from "react";
import FormSubmissionTable, { ColumnHeader } from "../formSubmissionsDataGrid";

const AgentIntakeFormSubmission: React.FC = () => {
  const columnHeaders: ColumnHeader[] = [
    {
      Column_Name: "Submission ID",
      Field_Name: "Submission_ID",
    },
    {
      Column_Name: "User Email",
      Field_Name: "User_Email",
    },
    {
      Column_Name: "Entry Date",
      Field_Name: "Entry_Date",
    },
    {
      Column_Name: "Agent Name",
      Field_Name: "agentName",
    },
    {
      Column_Name: "Agency Name",
      Field_Name: "agencyName",
    },
    {
      Column_Name: "Tax ID",
      Field_Name: "taxId",
    },
    {
      Column_Name: "Agent NPN",
      Field_Name: "agentNPN",
    },
  ];

  return <FormSubmissionTable columnHeaders={columnHeaders} formId={4} formName={"Agent Intake"}></FormSubmissionTable>;
};

export default AgentIntakeFormSubmission;
